import create from "zustand";
import { db } from "../../../../config/firebase.config";
import { doc, onSnapshot } from "firebase/firestore";
import { features } from '../../../../components/store-locator/avalanche-dealers.json'

export const useStore = create((set, get) => ({
    currentLocation: null,
    stores: [],
    realtimeStores: [],
    NoLocation: [],
    noLocationListener: false,
    // storeInRadius: null,
    // getStoresInRadius: (e) => {
    //     let arr = []
    //     get().storeInRadius.map(store => {
    //         if(store.distance <= parseInt(e.target.value)) {
    //             arr.push(store)
    //         }
    //     })
    //     set({storeInRadius: arr})
    //     return arr;
    // },
    getStoreNoLocation: ()=>{
        let storesWithoutDistance= []
        features.map(store => {
            const { address, city, country, email, id, phoneFormatted, province, storeName, website } = store.properties;
            const { coordinates } = store.geometry
            storesWithoutDistance.push({
                address,
                city,
                country,
                email,
                id,
                phoneFormatted,
                province,
                storeName,
                website,
                coordinates
            })
        })
        set({NoLocation : storesWithoutDistance })
        set({noLocationListener: true})
    },
    distanceCalculator: (payload) => {
        const {lat, lng, lat2, lon2, unit} = payload
        let radlat1 = Math.PI * lat / 180
        let radlat2 = Math.PI * lat2 / 180
        let theta = lng - lon2
        let radtheta = Math.PI * theta / 180
        let dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
        if (dist > 1) {
            dist = 1;
        }
        dist = Math.acos(dist)
        dist = dist * 180 / Math.PI
        dist = dist * 60 * 1.1515
        if (unit == "K") { dist = dist * 1.609344 }
        if (unit == "N") { dist = dist * 0.8684 }
        return dist
    },
    getStores: () => {
        let currentLocation = {}
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((position) => {
                currentLocation = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                }
                let storesWithoutDistance = []
                let formattedStores = []
                features.map(store => {
                    const { address, city, country, email, id, phoneFormatted, province, storeName, website } = store.properties;
                    const { coordinates } = store.geometry
                    storesWithoutDistance.push({
                        address,
                        city,
                        country,
                        email,
                        id,
                        phoneFormatted,
                        province,
                        storeName,
                        website,
                        coordinates
                    })
                    let payload = {
                        lat: currentLocation.lat,
                        lng: currentLocation.lng,
                        lat2: coordinates[1],
                        lon2: coordinates[0],
                        unit: "K",
                    };
                    store.distance = get().distanceCalculator(payload)
                    // formattedStores.push(store)
                    if(store.distance <= 10) {
                        formattedStores.push(store)
                    }
                })
                formattedStores.sort((a, b) => {
                    return a.distance > b.distance ? 1 : a.distance < b.distance ? -1 : 0 
                });
                // set({storeInRadius: formattedStores})
                let arr = []
                storesWithoutDistance.map((store) => {
                    let payload = {
                        lat: currentLocation.lat,
                        lng: currentLocation.lng,
                        lat2: store.coordinates[1],
                        lon2: store.coordinates[0],
                        unit: "K",
                    };
                    store.distance = get().distanceCalculator(payload)
                    arr.push(store)
                });
                arr.sort((a, b) => {
                   return a.distance > b.distance ? 1 : a.distance < b.distance ? -1 : 0 
                })
                // console.log("data", arr);
                set({stores: arr})
            });
          } else { 
            // console.log("stores", "Geolocation is not supported by this browser.")
          }
    }
}));